<template lang="pug">
  .app-container
    front-menu
    main.app-content
      section.hero.is-bold.is-fullheight.is-primary
        .hero-body
          .container
            .box
              form.has-text-left
                .content
                  h1 Download the frequency list
                  img.is-rounded.is-pulled-right(src="/static/frequency-list-english-preview.png" alt="Frequency List of English (preview)" title="Frequency List of English (preview)")
                  p.lead.pt-2.pb-2
                    | Simply fill in your name and e-mail address below, then click on the
                    |
                    strong
                      i Get the frequency list
                    |  button to receive the documents by e-mail.
                  p Your archive will contain:
                  ul
                    li
                      | The frequency list in various formats, i.e.:
                      |
                      strong the top 5,000 words in spoken American English
                      | ;
                    li
                      | The
                      |
                      strong frequency list in spreadsheet format
                      |  for you to use in
                      |
                      strong Excel,
                      |
                      | Numbers or your favorite spreadsheet program;
                    li
                      | The frequency list in
                      |
                      strong e-book formats
                      | :
                      ul
                        li
                          | for you to read on
                          |
                          strong Kindle
                          | , Kobo, iPhone, Android, your computer or on your favorite device for reading e-books (includes both EPUB and Kindle formats.)
                        li
                          | This is great to learn the words, because you can use the
                          |
                          strong dictionary included in your e-book reader
                          |
                          | to look up the words you don't know.
                  p I hope they will help you learn and teach vocabulary in English more efficiently.

                b-field(label="First name")
                  b-input#first_name(
                  icon="account-circle"
                  v-model="form.first_name"
                  type="text"
                  size="is-medium"
                  placeholder="Your first name"
                  )
                b-field(label="Email")
                  b-input#email(
                  icon="email"
                  v-model="form.email"
                  type="email"
                  required
                  size="is-medium"
                  placeholder="Email"
                  )
                b-field.my-brew.search.p3(label="Would you say you're a…")
                  div
                    b-radio(v-model="form.is_teacher" native-value="false")
                      | a student
                    b-radio(v-model="form.is_teacher" native-value="true")
                      | a teacher

                b-field.mt-2.is-align-content-flex-start(label="Newsletter")
                  b-checkbox.has-aligned-top(v-model="form.mail_consent")
                    | I subscribe to Frequency List newsletter
                    br
                    span.is-size-7
                      | We don't sell your contact info to any third party.<br />
                      | We will send you occasional updates on the projects we are working on, all language related. You can unsubscribe at any time.

                button#btn_sign_up.button.is-block.is-primary.is-medium.is-fullwidth(
                  :class="{'is-loading': isLoading, 'is-disabled': isLoading || !form.email.length || !form.first_name.length}"
                  @click="onSubmit($event)"
                  v-if="!isSuccess"
                  )
                  | Get the frequency list
                button#btn_sign_up.button.is-block.is-success.is-medium.is-fullwidth.is-flex(
                v-else
                )
                  b-icon(icon="check")
                  span Check your emails

                .message.is-danger.my-3(v-if="error")
                  .message-body(v-html="error")

                article.message.is-light.mt-1
                  .message-body



</template>


<script>
  import gdprConsent from "@/components/GdprConsent";


  export default {
    name: 'SignUp',
    components: {
      gdprConsent
    },
    data() {
      return {
        gdprConsented: Vue.cookie.get('gdprConsented'),
        error: null,
        form: {
          first_name: '',
          email: '',
          username: '',
          password: '',
          confirm_password: '',
          uuid: '',
          checked: true
        },
        redirect: null,
        isLoading: false,
        isSuccess: false,
        googleIsLoading: false,
        facebookIsLoading: false,
        googleSignInParams: {
          client_id: '271833066394-5cabmp4f2e6u5absa42afnno7ct5t19b.apps.googleusercontent.com',
          response_type: 'permission'
        },
        fbSignInParams: {
          scope: 'email',
          return_scopes: true
        }
      }
    },
    created() {
      // this.$store.dispatch('setLayout', 'front-layout')
      this.form.uuid = this.$store.getters.uuid
    },

    methods: {
      onSubmit(evt) {
        this.isLoading = true
        evt.preventDefault()
        this.$auth.register({
          body: {user: this.form},
          autoLogin: false,
          redirect: null,
          rememberMe: this.form.checked
        }).then((res) => {
          this.isLoading = false
          this.isSuccess = true
          // console.log('REGISTER REP ', res);
          // this.$mixpanel.alias(res.body.data.id);
          // this.$store.dispatch("setUser", res.body.data);
          // this.$emit('close');
        }, (res) => {
          console.log('error ' + this.context);
          this.error = res.data.message;
          this.isLoading = false
        });
      },
      onClick(e) {
        e.preventDefault();
        this.$router.push('/')
      },
      onSignInSuccess(googleUser) {
        this.$store.dispatch("setUserFromGoogle", {
          access_token: googleUser.Zi.access_token,
          uuid: this.$store.getters.uuid
        }).then((res) => {
          console.log(res);
          if (!res.user.existed) {
            this.$mixpanel.alias(res.user.id+'');
          }
          this.$auth.user(res.user)
          this.$store.dispatch("setUser", res.user);
          this.$auth.token(null, res.token)
          this.$auth.watch.authenticated = true
          this.$auth.watch.loaded = true
          this.googleIsLoading = false;
          this.$cookie.set('rememberMe', true, 365);
          // this.$router.push({name: 'FrontPage'});
          this.$emit('close');
          // document.querySelector('button.modal-close').click()
        });
      },
      onFbSignInSuccess(facebookUser) {
        console.log('FB USER: ', facebookUser)
      },
      onSignInError(error) {
        console.log("OH NOES", error);
        this.googleIsLoading = false;
      },
      onFbSignInError(error) {
        console.log("OH NOES", error);
        this.facebookIsLoading = false;
      }
    }
    /*created(evt) {
    console.log(evt)
      evt.preventDefault()
      axios.post(`http://localhost:3003/api/register`, this.form)
      .then(response => {
        // JSON responses are automatically parsed.
        this.form = response.data
      })
      .catch(e => {
        console.log(e)
      })


    },*/
  }
</script>


<style scoped>

  img {
    width: 400px;
    heitgh: auto;
  }

  input {
    font-weight: 300;
  }

  p {
    /*font-weight: 700;*/
  }

  p.subtitle {
    padding-top: 1rem;
  }

  a {
    text-decoration: none;
  }

  .w-480 {
    width: 480px;
    margin-top: 30px
  }

</style>



// WEBPACK FOOTER //
// src/components/SignUpPage.vue